import { connect } from 'react-redux';
import TopHeader from './TopHeader';
import { toggleFilterSidebar } from '../../../../redux/actions/filters';
import {
  loadUser,
  loadMySubscriptionPlan,
} from '../../../../redux/actions/user';
import {
  loadMergeAPIExploreRecipe,
  loadMergeAPIExploreRecipes,
  resetRecipeStatus,
  clearExploreDetails,
  resetEnrichment,
  saveBreadCrumbs,
  loadAttackSurfaceMapping,
  loadDigitalThreatManagement,
  loadMergeAPIExploreQueryBuilderSchemas,
} from '../../../../redux/actions/ioc';
import { toggleLeftMenu } from '../../../../redux/actions/filters';
import { logout } from '../../../../redux/actions/auth';
import { loadDashboards } from '../../../../redux/actions/dashboards';
import { selectDashboards } from '../../../../redux/selectors/dashboards';

const mapStateToProps = (state, props) => ({
  user: state.user.user,
  titleText: state.app.titleText,
  auxillaryText: state.app.auxillaryText,
  dashboards: selectDashboards(state),
  exploreRecipe: state.ioc.exploreRecipe,
  recipeStatus: state.ioc.recipeStatus,
  exploreRecipes: state.ioc.exploreRecipes,
  recipesStatus: state.ioc.recipesStatus,
  leftMenuSideBarCollapsed: state.sidebar.leftMenuSideBarCollapsed,
  paginationStatus: state.ioc.paginationStatus,
  mySubscriptionPlan: state.user.mySubscriptionPlan,
  mySubscriptionPlanStatus: state.user.mySubscriptionPlanStatus,
});

const mapDispatchToProps = {
  toggleFilterSidebar,
  loadMergeAPIExploreRecipes,
  loadMergeAPIExploreRecipe,
  loadUser,
  logout,
  loadDashboards,
  resetRecipeStatus,
  resetEnrichment,
  toggleLeftMenu,
  clearExploreDetails,
  loadMySubscriptionPlan,
  saveBreadCrumbs,
  loadAttackSurfaceMapping,
  loadDigitalThreatManagement,
  loadMergeAPIExploreQueryBuilderSchemas,
};

export default connect(mapStateToProps, mapDispatchToProps)(TopHeader);
